export const SessionStatus = function (session_nid) {
  const map = {
    'onair': 'LIVE',
    'upcoming': 'UPCOMING',
    'past': 'PAST',
    'ondemand': 'ON-DEMAND'
  };
  return {
    sid: session_nid,
    status: '',

    async init() {
      this.$el.innerHTML = `<div x-show="status">Status: <span class="state" x-text="status"></span></div>`;
      const {status} = await fetch(`/se/popup/sessiontimer-sessionstatus/${_current_expoid()}/${this.sid}`).then((response) => {
        return response.json();
      });
      this.status = map[status] ?? 'PAST';
    }
  }
}